import React from 'react';
import AutomationIcon from './AutomationIcon';
import Badge from '../../shared/components/Badge';
import { BLOCKED_BUYERS_COPY, PAGE_COPY } from '../constants/automationRules';

// The block list used to be reachable only while its rule was on, which stranded everyone
// already blocked the moment a team switched the rule off. This card never hides.
//
// No count and a disabled button: PaymentReviews::BlockList writes into Stripe Radar value
// lists and nothing else, so there is no local record to count and no path to take an entry
// back off. Rendering the affordance disabled — rather than omitting it — is what tells a
// team the capability exists and how to reach it in the meantime.
const BlockedBuyersCard = () => (
  <div className="automation-rules__card" role="group" aria-labelledby="blocked-buyers-title">
    <div className="automation-rules__blocked">
      <span className="automation-rules__card-icon" aria-hidden="true">
        <AutomationIcon name={BLOCKED_BUYERS_COPY.icon} />
      </span>
      <div className="automation-rules__card-main">
        <div className="automation-rules__card-titles">
          <span className="automation-rules__card-title" id="blocked-buyers-title">
            {BLOCKED_BUYERS_COPY.title}
          </span>
          <Badge label={PAGE_COPY.comingSoon} tone="neutral" />
        </div>
        <p className="automation-rules__card-description" id="blocked-buyers-help">
          {BLOCKED_BUYERS_COPY.body}
        </p>
      </div>
      <button
        type="button"
        className="btn btn-setlist-secondary automation-rules__button"
        disabled
        aria-describedby="blocked-buyers-help"
        data-testid="blocked-buyers-review"
      >
        {BLOCKED_BUYERS_COPY.action}
      </button>
    </div>
  </div>
);

export default BlockedBuyersCard;
